import { Component, OnInit, ViewEncapsulation, HostListener, Inject } from '@angular/core';
import { AboutUsService } from './about-us.service';
import { NotificationService } from './../../shared/services/notification.service';
import { TitleMetadataService } from './../../shared/services/title-metadata.service';
import { Router } from '@angular/router';
import { WINDOW } from './../../shared/services/general-operations.service';
import { Constants } from './../../shared/constants';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AboutUsComponent implements OnInit {
  jobsLink:string = Constants.jobsLink;
  slidesToShow: number = 3;
  slidesToScroll: number = this.slidesToShow;
  selectedCrew: any;
  frequentlyPurchasedSlideConfig: { slidesToShow: number; slidesToScroll: number; dots: boolean; infinite: boolean; };
  customerQuotes: any;
  ourCrew: any;
  constructor(
    @Inject(WINDOW) private window: Window,
    private aboutUsService: AboutUsService,
    private notificationService: NotificationService,
    private router: Router,
    private titleService: TitleMetadataService
  ) {
  }

  ngOnInit() {
    this.titleService.createCanonicalURL(this.router.url);
    if (this.window.innerWidth < 768) {
      this.slidesToScroll = 1;
      this.slidesToShow = 1;
    }
    this.setSliderConfigurations();
    this.getCustomerQuotes();
    this.getOurCrew();
    this.frequentlyPurchasedSlideConfig = {
      slidesToShow: this.slidesToShow,
      slidesToScroll: this.slidesToScroll,
      dots: false,
      infinite: false
    };
  }

  setSliderConfigurations(): void {
    this.frequentlyPurchasedSlideConfig = {
      slidesToShow: this.slidesToShow,
      slidesToScroll: this.slidesToScroll,
      dots: false,
      infinite: false
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 768) {
      this.slidesToScroll = 1;
      this.slidesToShow = 1;
    } else {
      this.slidesToScroll = 3;
      this.slidesToShow = 3;
    }
    this.setSliderConfigurations();
  }

  // Get - Customer Quotes response from post operation
  getCustomerQuotes(): void {
    this.aboutUsService.getCustomerQuotes()
      .subscribe(res => {
        this.customerQuotes = res.customerQuotes;
      }, err => {
        this.notificationService.showError(err);
      });
  }

  // Get - Our Crew response from post operation
  getOurCrew(): void {
    this.aboutUsService.getOurCrew().subscribe(res => {
      this.ourCrew = res.ourCrew;
      if (this.ourCrew) {
        this.selectedCrew = this.ourCrew[0];
      }
    }, err => {
      this.notificationService.showError(err);
    });
  }

  selectCrew(crew): void {
    this.selectedCrew = crew;
  }

  isActive(crew) {
    return this.selectedCrew === crew;
  };

}
